module.exports =
{

  _init: function ()
  {
    APPLICATION.PodConfigurator.confirm._init()
  },

}